// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1791":"5eb602a4","4003":"66ca3305","4749":"7ea55d03","7140":"2640a820","7529":"298ca823","9555":"33c15387"}[chunkId] + ".chunk.css";
};